const calcBirthToAge = (date) => {
    if (!date) return '';
    const parts = String(date).split('-');
    const birthdate =
        parts.length === 3
            ? new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10))
            : new Date(date);
    const today = new Date();

    let age = today.getFullYear() - birthdate.getFullYear();
    const hasHadBirthdayThisYear =
        today.getMonth() > birthdate.getMonth() ||
        (today.getMonth() === birthdate.getMonth() && today.getDate() >= birthdate.getDate());

    if (!hasHadBirthdayThisYear) {
        age--;
    }

    return age;
}

export default calcBirthToAge;